import { environment } from '@/config'
import { watch } from 'vue'
import type { RouteLocationNormalizedLoaded, Router } from 'vue-router'
import { validateApiEndpoint } from '@/utils/dynamicBackendApiEndpoint'

/**
 * Normalize URLs by removing trailing slash `/`
 * @param url
 */
const withoutTrailingSlash = (url: string) =>
  url.endsWith('/') ? url.slice(0, -1) : url

export function useDynamicBackendApiEndpoint({
  route,
  router,
}: {
  route: RouteLocationNormalizedLoaded
  router: Router
}) {
  watch(
    [() => route.query.apiendpoint, () => route.query.pluginendpoint],
    async ([apiEndpoint, pluginEndpoint]) => {
      if (environment() === 'production') {
        // we don't want to expose this functionality in production
        return
      }

      let apiEndpointSaved = false
      let pluginEndpointSaved = false

      if (validateApiEndpoint(apiEndpoint)) {
        window.sessionStorage.setItem(
          'apiendpoint',
          withoutTrailingSlash(apiEndpoint),
        )
        apiEndpointSaved = true
      }
      if (validateApiEndpoint(pluginEndpoint)) {
        window.sessionStorage.setItem(
          'pluginendpoint',
          withoutTrailingSlash(pluginEndpoint),
        )
        pluginEndpointSaved = true
      }

      if (apiEndpointSaved || pluginEndpointSaved) {
        await router.replace({
          query: {
            ...route.query,
            apiendpoint: apiEndpointSaved
              ? undefined
              : route.query['apiendpoint'],
            pluginendpoint: pluginEndpointSaved
              ? undefined
              : route.query['pluginendpoint'],
          },
        })
        window.location.reload()
      }
    },
    {
      immediate: true,
    },
  )
}
